import React from 'react';
import axios from 'axios';
import { Col, Modal, Icon} from 'antd';
import Template from '../interfaz/Template';
import AuthenticatedComponent from '../AuthenticatedComponent';
import emitirMensaje from '../../redux/actions/emitirMensaje'
import {connect} from 'react-redux'
import * as etiquetas from '../../ApplicationResources';
import solicitudDeclinada from '../../img/info06_Declinado.png';
import imagenDeclino from '../../img/Declinacion.png'
import claveContacto from '../../img/modal_contacto.png';
import errorImgModal from '../../img/error_icon.svg';
import { implantarAspirante } from '../../redux/user/user-actions';

let msjError = "";

class SolicitudDeclinada extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            cargando: false
        };
    }

    listo = () => {
        if (this.props.datosAspirante.estatusRegistro !== 4 && this.props.datosAspirante.estatusRegistro !== 5)
            this.props.history.push('/loginSEyCAE');
    }

    render() {
        return(
            <AuthenticatedComponent listo={this.listo}>
                <Template contenido={
                    <React.Fragment>
                        <center>
                            <p/>
                                <img src={this.props.datosAspirante.estatusRegistro === 4 ? solicitudDeclinada : imagenDeclino} alt="SolicitudDeclinada" width="70%" height="60%"/>
                            <p/>
                        </center>
                    </React.Fragment>
                }
                contenidoExpandido={true} cargando={this.state.cargando} />
            </AuthenticatedComponent>
        );
    }
};

const mapStateToProps = state => {
    var datosAspirante;
    var proceso = undefined;

    // Obtenemos el proceso seleccionado de la store de redux
    if(state.menu.estados)
        if(state.menu.estados[state.menu.idEstado].procesos)
            proceso = state.menu.estados[state.menu.idEstado].procesos[state.menu.idDetalle];

    if (state.user.datosAspirante)
        datosAspirante = state.user.datosAspirante;
    else
        datosAspirante = {estatusRegistro: 0};

    return {
        operaciones: state.operaciones,
        datosAspirante: datosAspirante,
        proceso: proceso     
    }
}

const mapDispatchToProps = dispatch => ({
	implantarAspirante: aspirante => dispatch(implantarAspirante(aspirante)),
    emitirMensaje: valor => dispatch(emitirMensaje(valor))
});

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudDeclinada);
